var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"settings-center-rail"},[(
      ['telecom-fwd', 'telecom-trck', 'telecom-flow'].includes(
        _vm.settingsNavSelected
      )
    )?_c('telecom-settings',{ref:"telecom-pane"}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }